<app-header></app-header>
<!-- <app-banner-enquiry-form></app-banner-enquiry-form> -->
<app-banner-enquiry-form [backgroundImageId]="'7'" [loanTypeId]="18"  serviceName="term plan planning"></app-banner-enquiry-form>>

<div class="plan-section">
  <h2 class="plan-title">Term Plan</h2>
  <p class="plan-description">
    In India, where <strong>financial planning</strong> is increasingly recognized, term plans play a pivotal role in securing one's economic future. We are passionate about empowering our clients to make informed decisions. Let's delve into the specifics of how term plans can be a game-changer in financial planning in India.
  </p>

  <h3 class="important-heading">
    Why is Children's Marriage Planning Important?
  </h3>
  <div class="underline"></div>





  <!-- Service Sections -->
  <section class="service-section">
    <div class="content">
      <h2>Introduction</h2>
      <p>
        In India, where the importance of <strong>financial planning</strong> is becoming increasingly recognized, term plans play a pivotal role in securing one's financial future. We are passionate about empowering our clients to make informed decisions. Let's delve into the specifics of how term plans can be a game-changer in financial planning in India.
      </p>
    </div>
    <img src="assets/Services/fplanning.svg" alt="Financial Planning Introduction">
  </section>

  <section class="service-section">
    <img src="assets\tmp\23156212_safemoney_1.jpg" alt="Understanding Financial Situation">
    <div class="content">
      <h2>1. Financial Protection:</h2>
      <p>
        Term plans offer a <strong>financial safety net </strong>for your loved ones in the event of your untimely demise. The sum assured can help them maintain their lifestyle, pay off debts, and cover expenses such as education and healthcare.
    </p>
    </div>
  </section>
<!-- Cost-Effectiveness Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>2. Cost-Effectiveness</h2>
    <p>
      Term plans are known for their affordability, making them accessible to a wide range of individuals. This allows you to secure substantial coverage at a fraction of the cost of other insurance products.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/tmp/137387023_7811b5da-d6fd-4ff1-903d-0dcb21d58338.jpg" alt="Cost-Effective Term Plans">
  </div>
</section>


  <section class="service-section">
    <img src="assets\tmp\exchange_7.jpg" alt="Developing a Financial Plan">
    <div class="content">
      <h2>3. Flexibility:</h2>
      <p>
        Term plans in India come with various options, such as choosing the <strong>coverage amount,</strong>  policy term, and <strong>premium payment frequency,</strong> which can be tailored to meet your specific needs.      </p>
    </div>
  </section>
<!-- Tax Benefits Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>4. Tax Benefits</h2>
    <p>
      Term plan premiums are eligible for tax deductions under <strong>Section 80C of the Income Tax Act</strong>, providing additional savings.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/tmp/online-tax-filing-concept-businessman-filling-tax-form-documents-online-vector-illustration.png" alt="Tax Benefits for Term Plans">
  </div>
</section>

  <section class="service-section">
    <img src="assets\tmp\19743030_stress_11.jpg" alt="Developing a Financial Plan">
    <div class="content">
      <h2>5.Peace of Mind</h2>
      <p>
        Knowing that your loved ones are financially protected in your absence can give you <strong>peace of mind</strong> allowing you to focus on other aspects of your life without worrying about your <strong>financial security.</strong></p>  </div>
  </section>
 <!-- Conclusion Section -->
<section class="service-section">
  <!-- Text Content -->
  <!-- <div class="content order-md-1 order-2">
    <h2>Conclusion</h2>
    <p>
      Term plans are an integral part of <strong>financial planning</strong> in India, offering a cost-effective way to provide financial protection for your loved ones. As a <strong>Wealth Business Coach</strong>, I am committed to helping <strong>Financial Advisors</strong> and their clients navigate the complexities of financial planning and make informed decisions that secure their future.
    </p>
  </div> -->

  <!-- Image -->
  <!-- <div class="order-md-2 order-1">
    <img src="assets/Services/fd.svg" alt="Financial Planning Assistance">
  </div> -->
</section>

</div>


<section class="contact-us-section">
  <div class="contact-content">
    <h2>Contact Us  Today!</h2>
    <p class="slogan">Your journey to financial freedom starts here!</p>
  </div>

  <div class="contact-form-container">
    <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="contact-form">
      <h2>Submit Your Enquiry</h2>
      <input formControlName="full_name" type="text" placeholder="Your Name" required>
      <input formControlName="email" type="email" placeholder="Your Email" required>
      <input formControlName="phone" type="tel" placeholder="Your Phone Number" required>
      <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
      <textarea formControlName="enq_detail_msg" placeholder="Your Message" required></textarea>
      <button type="submit" [disabled]="enquiryForm.invalid">Send Message</button>
    </form>

    <!-- Standard message after submission -->

  <!-- Thank you message with animated smiley -->
  <div *ngIf="isEnquirySubmitted" class="thank-you-message animated">
    <h3>
      Thank you for your enquiry! We will get back to you shortly!
      <span class="smiley">😊</span>
    </h3>
  </div>
  </div>

</section>



<app-footer></app-footer>
